export default function createServicerBankAccountsOptions(
  servicerBankAccounts
) {
  if (!servicerBankAccounts) {
    return [];
  }

  const filteredBankAccounts = servicerBankAccounts?.filter((bAcc) => {
    return !!bAcc.billcom_customer_id;
  });

  const options = ['Operating', 'Clearing', 'Impound'];
  const bankAccountsWithOptions = [];
  options.forEach((opt) => {
    const bankAccount = filteredBankAccounts.find(
      (bAcc) => bAcc.function === opt.toLowerCase()
    );

    if (bankAccount) {
      bankAccountsWithOptions.push({
        id: bankAccount.id,
        option: opt,
      });
    }
  });

  return bankAccountsWithOptions;
}
